import React, {useState} from "react";
import validator from "validator";
import Alert from "../Alert";
import configVars from "../../config";
//import { setWithExpiry } from '../../common';
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

const AddNewMember = ({ organization, userData }) => {

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [translation] = useTranslation("translations");
    const [isManager, setIsManager] = useState(false);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const handleSubmit = (event) => {
        event.preventDefault();

        setIsError( false );
        setErrorMsg( '' );
        setIsSuccess( false );

        const validation = handleValidation( firstName, lastName, userEmail);

        if ( !validation.isValidated ) {
            setIsError( true );
            setErrorMsg( validation.validationMsg );
            return;
        }

        setIsSaving( true );

        handleAddMember().then( (memberResponse) => {

            if ( memberResponse ) {
                
                if ( memberResponse.success === true ) {

                    setIsSuccess( true );
                    setErrorMsg( memberResponse.message );

                    //setWithExpiry( `sy_org_${organization}_data`, memberResponse.data );

                    userData( memberResponse.data.users );

                    localStorage.removeItem( `sy_org_${organization}_data` );
                    window.location.reload();

                } else {

                    setIsError( true );
                    setErrorMsg( memberResponse.message );

                }

            }

            setIsSaving( false );

        });

    }

    const handleValidation = (firstName, lastName, userEmail) => {

        let isValidated = true;
        let validationMsg = '';

        if ( ! firstName.toString().trim().length || ! lastName.toString().trim().length || ! userEmail.toString().trim().length ) {
            isValidated = false;
            validationMsg = translation("fill_required_fields");
        }

        if ( !validator.isEmail(userEmail) ) {
            isValidated = false;
            validationMsg = translation("enter_valid_email");
        }

        return {
            'isValidated' : isValidated,
            'validationMsg': validationMsg
        }

    }

    const handleAddMember = async () => {

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'organization_id', organization );
            userRequestData.append( 'first_name', firstName );
            userRequestData.append( 'last_name', lastName );
            userRequestData.append( 'email', userEmail );

        if ( isManager ) {
            userRequestData.append( 'is_manager', isManager );
        }

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/addorganizationmember/`;

        const response = await fetch(
            fetchUrl,
            {
              method: "POST",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
              },
              body: userRequestData
            }
        );

        const memberResponse = await response.json();

        return memberResponse;

    }


    return (
        <div className="row mt-5">

            <div className="col-12">
                <h3>{translation("add_new_member")}</h3>

                {isError &&
                    <div className="mt-3" style={{ maxWidth: "800px" }}>
                        <Alert type="danger" msg={errorMsg}  />
                    </div>
                }

                {isSuccess &&
                    <div className="mt-3" style={{ maxWidth: "800px" }}>
                        <Alert type="success" msg={errorMsg}  />
                    </div>
                }

                <form className="mt-4" style={{ maxWidth: "800px" }} onSubmit={ (event) => handleSubmit(event) }>
                    <div className="row mb-3">
                        <div className="col-12 col-lg-6">
                            <input type="text" name="first_name" className="form-control" placeholder={translation("first_name")} value={firstName} onChange={ (e) => setFirstName(e.target.value) } /> 
                        </div>
                        <div className="col-12 col-lg-6">
                            <input type="text" name="last_name" className="form-control" placeholder={translation("last_name")} value={lastName} onChange={ (e) => setLastName(e.target.value) } /> 
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <input type="email" name="member_email" className="form-control" placeholder={translation("email_address")} value={userEmail} onChange={ (e) => setUserEmail(e.target.value) } />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="member_type" value={isManager} onChange={() => setIsManager(!isManager)} />
                                <label className="form-check-label" htmlFor="member_type">Make Manager</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button type="submit" className="btn btn-secondary w-100">
                                {isSaving &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                                {!isSaving &&
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                }
                                <span className="ps-3">{translation("buttons.save")}</span>
                            </button>
                        </div>
                    </div>
                    
                </form>

            </div>
        </div>
    );
};

export default AddNewMember;
